/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_TransferInputs */

const en_cc_transfer = /** @type {(inputs: Cc_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add link to Calendar draft`)
};

const id_cc_transfer = /** @type {(inputs: Cc_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan tautan ke draf Calendar`)
};

/**
* | output |
* | --- |
* | "Add link to Calendar draft" |
*
* @param {Cc_TransferInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_transfer = /** @type {((inputs?: Cc_TransferInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_TransferInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_transfer(inputs)
	return en_cc_transfer(inputs)
});